export default __webpack_public_path__ + "static/media/z050ma0a.070ac4a2.mp3";